(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('tgex-polished-navigation')) {
    customElements.define('tgex-polished-navigation', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.mobileToggle = this.querySelector('.tgex-h__mobile-toggle');
        this.navigation = this.querySelector('.tgex-h__navigation');
        this.groups = Array.from(this.querySelectorAll('.tgex-h__group'));
        this.breakpoint = window.matchMedia('(min-width: 750px)');
        this.setAttribute('data-enhanced', '');
        this.mobileToggle.addEventListener('click', () => this.setMenuOpen(!this.hasAttribute('data-menu-open')), options);
        this.querySelector('.tgex-h__menu-close').addEventListener('click', () => this.setMenuOpen(false, true), options);
        this.groups.forEach(group => {
          group.addEventListener('toggle', () => {
            if (group.open) this.groups.forEach(other => { if (other !== group) other.open = false; });
          }, options);
        });
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          const activeGroup = this.groups.find(group => group.open);
          if (activeGroup) {
            activeGroup.open = false;
            activeGroup.querySelector('summary').focus();
            event.preventDefault();
            event.stopPropagation();
          } else if (this.hasAttribute('data-menu-open')) {
            this.setMenuOpen(false, true);
            event.preventDefault();
            event.stopPropagation();
          }
        }, options);
        document.addEventListener('click', event => {
          if (!this.contains(event.target)) this.closeAll();
        }, options);
        this.addEventListener('focusout', event => {
          if (event.relatedTarget && !this.contains(event.relatedTarget)) this.closeAll();
        }, options);
        this.addEventListener('click', event => {
          if (event.target.closest('.tgex-h__actions')) this.closeAll();
        }, options);
        this.onBreakpointChange = () => this.closeAll();
        this.breakpoint.addEventListener('change', this.onBreakpointChange);
      }
      setMenuOpen(open, restoreFocus = false) {
        this.toggleAttribute('data-menu-open', open);
        this.mobileToggle.setAttribute('aria-expanded', String(open));
        this.mobileToggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
        if (!open) this.groups.forEach(group => { group.open = false; });
        if (restoreFocus) this.mobileToggle.focus();
      }
      closeAll() {
        if (this.mobileToggle) this.setMenuOpen(false);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.breakpoint?.removeEventListener('change', this.onBreakpointChange);
        this.controller = null;
      }
    });
  }
  if (!customElements.get('sticky-header')) {

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = this.closest('.section-header') || this.parentElement;
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      const initialRect = this.header.getBoundingClientRect();
      this.headerBounds = { top: initialRect.top + window.scrollY, bottom: initialRect.bottom + window.scrollY };
      this.setHeaderHeight();
      this.headerResizeObserver = new ResizeObserver(() => this.setHeaderHeight());
      this.headerResizeObserver.observe(this.header);
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.headerResizeObserver?.disconnect();
      this.boundsObserver?.disconnect();
      window.clearTimeout(this.isScrolling);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      this.boundsObserver = observer;
      observer.observe(this.header);
    }
    onScroll() {
      if (this.header.querySelector('tgex-polished-navigation[data-menu-open], .tgex-h__group[open]')) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
      this.header.querySelector('tgex-polished-navigation')?.closeAll();
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mlv-faq-section"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.faq-item').forEach(item => {
  const question = item.querySelector('.faq-question');
  const answer = item.querySelector('.faq-answer');

  question.addEventListener('click', () => {
    item.classList.toggle('active');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgex-gift-card"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tgex-gift-card-page')) {
    customElements.define('tgex-gift-card-page', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.button = this.querySelector('[data-gift-submit]');
        this.send = this.querySelector('[data-gift-send]');
        this.fields = this.querySelector('[data-gift-fields]');
        this.email = this.querySelector('[data-gift-email]');
        this.message = this.querySelector('[data-gift-message]');
        this.counter = this.querySelector('[data-gift-count]');
        this.error = this.querySelector('[data-gift-error]');
        this.errorText = this.querySelector('[data-gift-error-text]');
        this.status = this.querySelector('[data-gift-status]');
        this.busy = false;
        this.querySelector('[data-gift-options]').hidden = false;
        this.send.disabled = false;
        this.querySelector('[data-gift-offset]').value = String(new Date().getTimezoneOffset());
        const today = new Date();
        const localDate = [today.getFullYear(), String(today.getMonth() + 1).padStart(2,'0'), String(today.getDate()).padStart(2,'0')].join('-');
        this.querySelector('[data-gift-date]').min = localDate;
        this.send.addEventListener('change', () => this.updateRecipient(true), options);
        this.message.addEventListener('input', () => this.updateCounter(), options);
        this.form.addEventListener('change', event => {
          if (event.target.name === 'id') {
            this.updateVariant();
            this.error.hidden = true;
          }
        }, options);
        this.form.addEventListener('submit', event => this.submitGift(event), options);
        window.addEventListener('pageshow', () => {
          this.busy = false;
          this.form.removeAttribute('aria-busy');
          this.updateVariant();
        }, options);
        this.updateRecipient(false);
        this.updateVariant();
        this.updateCounter();
      }
      updateRecipient(announce) {
        const enabled = this.send.checked;
        this.fields.disabled = !enabled;
        this.fields.hidden = !enabled;
        this.email.required = enabled;
        this.send.setAttribute('aria-expanded', String(enabled));
        if (announce) this.status.textContent = enabled ? 'Gift recipient fields are open.' : 'Gift will be sent to the email used at checkout.';
      }
      updateCounter() {
        this.counter.textContent = `${this.message.value.length} / 200 characters`;
      }
      updateVariant() {
        const selected = this.form.querySelector('input[name="id"]:checked');
        this.available = Boolean(selected && !selected.disabled);
        this.button.disabled = this.busy || !this.available;
        this.button.textContent = this.busy ? 'Adding…' : this.available ? 'Add gift card to cart' : 'Sold out';
      }
      showError(message) {
        this.errorText.textContent = message;
        this.error.hidden = false;
        this.status.textContent = '';
        this.error.focus();
      }
      async submitGift(event) {
        event.preventDefault();
        if (this.busy) return;
        this.updateVariant();
        if (!this.available || !this.form.reportValidity()) return;
        const body = new FormData(this.form);
        this.busy = true;
        this.error.hidden = true;
        this.form.setAttribute('aria-busy', 'true');
        this.status.textContent = 'Adding your gift card to the cart.';
        this.updateVariant();
        try {
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body
          });
          const data = await response.json();
          if (!this.isConnected) return;
          if (!response.ok || data.status) {
            const details = data.errors && typeof data.errors === 'object'
              ? Object.values(data.errors).flat().join(' ')
              : typeof data.errors === 'string' ? data.errors : '';
            const description = typeof data.description === 'string' ? data.description : '';
            this.showError(details || description || 'This gift card could not be added. Please check your selection and recipient details.');
            return;
          }
          this.status.textContent = 'Gift card added. Opening your cart.';
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          if (this.isConnected) this.showError('We could not confirm whether your gift card was added. Please check your cart before trying again.');
        } finally {
          this.busy = false;
          this.form.removeAttribute('aria-busy');
          this.updateVariant();
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
